import includes from 'lodash/includes';

import type { DetectorParams } from '../types';
import { referralAndTextRoutes, searchEngines, seoRoutes } from '../const';

/**
 * Detect the seo channel
 */
export const isSeoChannelFn = ({ utmSource, firstUrl, firstReferer, referrerMedium }: DetectorParams): boolean => {
  if (utmSource) {
    return false;
  }

  if (referralAndTextRoutes.some((v) => includes(firstUrl?.pathname, v))) {
    return false;
  }

  return (
    seoRoutes.some((v) => includes(firstUrl?.href, v)) &&
    (referrerMedium === 'search' || searchEngines.some((v) => includes(firstReferer, v)))
  );
};
